import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import StorefrontLayout from "@/components/StorefrontLayout";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function googleSignIn() {
  const redirectUrl = window.location.origin + "/auth/callback";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export default function CustomerSignup() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const r = await api.post("/auth/customer/register", form);
      setUser({ ...r.data, role: "customer" });
      nav("/account");
    } catch (e) {
      setErr(e?.response?.data?.detail || "Could not register.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <StorefrontLayout>
      <section className="max-w-md mx-auto px-6 py-20">
        <div className="label-mono mb-3">/ CREATE ACCOUNT</div>
        <h1 className="font-display text-5xl font-medium tracking-tight">Join the list.</h1>
        <p className="mt-3 text-base" style={{ color: "var(--ink-soft)" }}>First access to new editions.</p>

        <button data-testid="google-signup-btn" onClick={googleSignIn} className="btn-ghost w-full justify-center mt-8">
          <span className="font-mono-ui mr-1">G</span> Continue with Google
        </button>
        <div className="my-6 flex items-center gap-3 text-xs" style={{ color: "var(--ink-mute)" }}>
          <div className="h-px flex-1" style={{ background: "var(--rule)" }} /> OR <div className="h-px flex-1" style={{ background: "var(--rule)" }} />
        </div>

        <form onSubmit={submit} className="space-y-3">
          <label className="block">
            <span className="label-mono">Name</span>
            <input data-testid="signup-name" required value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              className="mt-2 w-full px-4 py-3 rounded-lg outline-none"
              style={{ background: "var(--paper)", border: "1px solid var(--rule)" }} />
          </label>
          <label className="block">
            <span className="label-mono">Email</span>
            <input data-testid="signup-email" type="email" required value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="mt-2 w-full px-4 py-3 rounded-lg outline-none"
              style={{ background: "var(--paper)", border: "1px solid var(--rule)" }} />
          </label>
          <label className="block">
            <span className="label-mono">Password (min 6)</span>
            <input data-testid="signup-password" type="password" required minLength={6} value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="mt-2 w-full px-4 py-3 rounded-lg outline-none"
              style={{ background: "var(--paper)", border: "1px solid var(--rule)" }} />
          </label>
          {err && <div data-testid="signup-err" className="text-sm font-mono-ui" style={{ color: "var(--accent)" }}>{err}</div>}
          <button data-testid="signup-submit" disabled={busy} className="btn-pill w-full justify-center">
            {busy ? "Creating…" : "Create account →"}
          </button>
        </form>

        <p className="mt-6 text-sm" style={{ color: "var(--ink-soft)" }}>
          Already a member? <Link to="/login" className="underline">Sign in</Link>
        </p>
      </section>
    </StorefrontLayout>
  );
}
